import { render, staticRenderFns } from "./rm-scroll.vue?vue&type=template&id=06dd8ab0&"
import script from "./rm-scroll.vue?vue&type=script&lang=js&"
export * from "./rm-scroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports